import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class HomeBanner {
	constructor() {
		this.container = document.querySelector('[data-home-banner]')

		if (!this.container) return

		this.tl = null
		this.#init()
	}

	#init() {
		this.tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.container,
				start: 'top top',
				end: '50% top',
				scrub: true,
			},
		})

		this.tl.to(this.container, {
			paddingLeft: 16,
			paddingRight: 16,
		})
	}
}
